import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import DiscountDelete from "./DeleteDiscountCode";
import UpdateDiscountCode from "./UpdateDiscountCode";

const DiscountActionButton = ({ id, handleDelete, handleEdit }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const params = useParams();
  const businessId = params?.business_id;

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };

  const toggleEditModal = () => {
    setShowEdit(!showEdit);
  }

  return (
    <>
      <span>
        <FontAwesomeIcon 
          icon={faEdit} 
          size="1x" 
          onClick={toggleEditModal}
          data-toggle="modal"
          // data-target="#editDiscount"
        />
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <FontAwesomeIcon
          onClick={toggleDeleteModal}
          icon={faTrash}
          size="1x"
          data-toggle="modal"
          // data-target="#deleteDiscount"
        />
      </span>

      {showDelete && (
        <DiscountDelete
          discountId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
          businessId={businessId}
        />
      )}

      {showEdit && (
        <UpdateDiscountCode
          discountId={id}
          toggleEditModal={toggleEditModal}
          handleEdit={handleEdit}
          showEdit={showEdit}
          businessId={businessId}
        />
      )}
    </>
  );
};

export default DiscountActionButton;
